
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import { BigCheckbox, Flex, FlexItem, Size, Margin } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const Wrapper = () => {
  const [values, setValues] = useState({
    first: false,
    second: false,
    third: false
  });
  return <Playground component={BigCheckbox} mdxType="Playground">
      <Flex mdxType="Flex">
        <FlexItem flex mdxType="FlexItem">
          <Margin size={{
          right: Size.DEFAULT
        }} mdxType="Margin">
            <BigCheckbox label="Title" value={values.first} onChange={v => setValues({
            ...values,
            first: v
          })} mdxType="BigCheckbox">
              <div style={{
              height: 100,
              background: 'blue'
            }} />
            </BigCheckbox>
          </Margin>
        </FlexItem>
        <FlexItem flex mdxType="FlexItem">
          <Margin size={{
          right: Size.DEFAULT
        }} mdxType="Margin">
            <BigCheckbox label="Another title" value={values.second} onChange={v => setValues({
            ...values,
            second: v
          })} mdxType="BigCheckbox">
              <div style={{
              height: 100,
              background: 'blue'
            }} />
            </BigCheckbox>
          </Margin>
        </FlexItem>
        <FlexItem flex mdxType="FlexItem">
          <BigCheckbox label="Yeah" value={values.third} onChange={v => setValues({
          ...values,
          third: v
        })} mdxType="BigCheckbox">
            <div style={{
            height: 100,
            background: 'blue'
          }} />
          </BigCheckbox>
        </FlexItem>
      </Flex>
    </Playground>;
};

const layoutProps = {
  Wrapper
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Big Checkbox`}</h1>
<p>{`Is used for more complex UIs where multiple choices are available. Accepts similar props to a `}<inlineCode parentName="p">{`Checkbox`}</inlineCode>{` component but does not look the same. This kind of checkbox "button" is not to be used in regular forms, similarly to the `}<inlineCode parentName="p">{`BigRadio`}</inlineCode>{` component. Often used together with other `}<inlineCode parentName="p">{`BigCheckbox`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { BigCheckbox } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>

<Wrapper mdxType="Wrapper" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;